import { createSlice, PayloadAction } from "@reduxjs/toolkit"; // Importing Redux Toolkit functions for creating slice and handling actions
import { IModalState, ModalType } from "../../../Types/UserProfileDetails"; // Importing types for modal state and modal type
import { userInformationModals } from "../../../utils/Constant";

// Initial state for the modal management
const initialState: IModalState = {
  isOpen: false, // Default state is that the modal is closed
  modalType: null, // Initially, no modal type is selected
  selectedId: null, // Initially, no ID is selected for the modal (could be used for specific data)
};

// Slice to manage modal state for user profile details
export const userProfileDetailsModalSlice = createSlice({
  name: userInformationModals, // Name of the slice (helps with debugging)
  initialState, // Initial state of the modal management
  reducers: {
    // Action to open the modal
    openModal(
      state, // Current state
      action: PayloadAction<{
        modalType: ModalType;
        selectedId?: string | number | null;
      }> // Action payload containing modal type and optionally selected ID
    ) {
      state.isOpen = true; // Set the modal open state to true
      state.modalType = action.payload.modalType; // Set the modal type based on the action payload
      state.selectedId = action.payload.selectedId; // Set the selected ID (could be null, number, or string)
    },

    // Action to close the modal
    closeModal(state) {
      state.isOpen = false; // Set the modal open state to false, effectively closing it
      state.modalType = null; // Reset the modal type to null
      state.selectedId = null; // Reset the selected ID to null
    },
  },
});

// Exporting the actions for use in components
export const { closeModal, openModal } = userProfileDetailsModalSlice.actions;

// Exporting the reducer to be included in the Redux store
export default userProfileDetailsModalSlice.reducer;
